import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Container } from '@design-system/container';
import { Content } from './Content';
export const ContentOnly = ({ description, filteredControls, isPreview, showControls, showDescription, title, }) => {
    const contentHeight = {
        l: 252,
        m: 282,
        s: 'auto',
        xl: 310,
    };
    const maxWidthContent = {
        l: '100%',
        m: 535,
        s: '100%',
        xl: isPreview ? 'unset' : 792,
    };
    return (_jsx(StyledContainer, { "$showDescription": showDescription, dataTestId: "appheader-container", flexDirection: { _: 'column', m: 'row' }, children: _jsx(Content, { contentHeight: contentHeight, description: description, filteredControls: filteredControls, maxWidthContent: maxWidthContent, showControls: showControls, showDescription: showDescription, showPicture: false, title: title }) }));
};
const StyledContainer = styled(Container).attrs(({ $showDescription }) => ({
    justifyContent: 'start',
    p: {
        s: '24px 32px',
        m: '24px 32px',
        l: '24px 32px',
        xl: `${$showDescription ? '24px 616px 24px 32px !important' : '24px 32px'}`,
    },
    px: {
        l: 8,
        m: 6,
        s: 4,
    },
    py: { m: 6, s: 4 },
})) ``;
//# sourceMappingURL=ContentOnly.js.map